<template>
  <v-text-field
    dense
    v-model="password"
    :label="$t('label.password')"
    :type="showPassword ? 'text' : 'password'"
    class="stretch-append text-field-styling w-100"
    :error-messages="passwordErrors"
    :rules="rules"
    outlined
    rounded
    @blur="$emit('blur')"
    :hide-details="hideDetails"
  >
    <template slot="append">
      <span class="my-auto secondary--text text-caption cursor-pointer" @click="showPassword = !showPassword">{{ $t('label.show') }}</span>
    </template>
  </v-text-field>
</template>

<script>
export default {
  props: {
    value: { required: true },
    passwordErrors: { required: false, default: '' },
    hideDetails: { required: false, default: false },
    rules: { type: Array, required: false }
  },

  data() {
    return {
      password: '',
      showPassword: false
    }
  },

  watch: {
    password(val) {
      this.$emit('input', val)
    }
  },

  mounted() {
    this.password = this.value
  }
}
</script>

<style></style>
